export const KAKAO_OPEN_CHAT = {
  name: '나눔마린 단톡방',
  link: 'https://open.kakao.com/o/gqvLZ1ye',
};

export const CONSULTATION_EXTERNAL = {
  name: '상담 예약',
  link: 'https://nanummarine.kr/product/nanum_counsel/',
};

export const menu = {
  login: {
    link: '/login',
  },
  signup: {
    link: '/signup',
  },
  password: {
    link: '/password',
  },
  changepassword: {
    link: '/changepassword/:token',
  },
  oauthCallback: {
    link: '/oauth/callback/:provider',
  },
  oauthSignup: {
    link: '/oauth/signup',
  },
  oauthVerify: {
    link: '/oauth/verify/:token',
  },
  analysis: {
    name: '부동산 데이터 분석',
    estateObjectList: {
      name: '부동산 매물 분석 현황',
      link: '/analysis/estate',
    },
  },
  pricing: {
    name: '요금제',
    link: '/pricing',
  },
  subscribe: {
    link: '/subscribe/:plan',
  },
  subscription: {
    name: '구독 관리',
    link: '/subscription',
  },
  alert: {
    name: '급매 알림 설정',
    link: '/alert',
  },
};

export const menuList = [
  {
    name: menu.analysis.name,
    child: [
      {
        name: menu.analysis.estateObjectList.name,
        link: menu.analysis.estateObjectList.link,
      },
      {
        name: menu.alert.name,
        link: menu.alert.link,
      },
    ],
  },
  {
    name: '결제',
    child: [
      {
        name: menu.pricing.name,
        link: menu.pricing.link,
      },
      {
        name: menu.subscription.name,
        link: menu.subscription.link,
      },
    ],
  },
];
